import React, { createContext, useContext, useState } from "react";
import CookieSettingsModal from "./CookieSettingsModal";

type CookieSettingsProviderProps = {
  children?: React.ReactNode;
};

const CookieSettingsContext = createContext({
  showCookieSettings: () => {},
});

export const useCookieSettings = () => useContext(CookieSettingsContext);

export function CookieSettingsProvider(props: CookieSettingsProviderProps) {
  const [show, setShow] = useState(false);

  const showCookieSettings = () => setShow(true);

  return (
    <CookieSettingsContext.Provider value={{ showCookieSettings }}>
      <CookieSettingsModal show={show} onClose={() => setShow(false)} />
      {props.children}
    </CookieSettingsContext.Provider>
  );
}
